import { Injectable, QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionChapeauComponent } from '@shared/components/qs-questions/question-chapeau/question-chapeau.component';
import { QuestionMotifComponent } from '@shared/components/qs-questions/question-motif/question-motif.component';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class QsPreFedService {
    setPreviousQssResponses(
        listeReponsesQuestionsSanteSimplifie: any[],
        qssForm: FormGroup
    ) {
        listeReponsesQuestionsSanteSimplifie.forEach((reponse) => {
            if (reponse.idTailleM) {
                this.setQsReponseTaillePoids(qssForm, reponse);
            } else if (reponse.ouiNon) {
                this.setQssReponsesOuiNon(qssForm, reponse);
            }
        });
    }

    setPreviousQsResponses(
        listeReponsesQuestionsSante: any[],
        qsForm: FormGroup,
        questionChapeauComponents: QueryList<QuestionChapeauComponent>,
        questionMotifComponents: QueryList<QuestionMotifComponent>
    ) {
        listeReponsesQuestionsSante.forEach((reponse) => {
            if (reponse.idTailleM) {
                this.setQsReponseTaillePoids(qsForm, reponse);
            } else if (reponse.ouiNon) {
                this.setQsReponsesOuiNon(
                    qsForm,
                    reponse,
                    questionChapeauComponents,
                    questionMotifComponents
                );
            }
        });
    }

    private setQssReponsesOuiNon(qssForm: FormGroup, reponse: any) {
        qssForm.controls[reponse.numero].setValue(reponse.ouiNon === 'oui');
    }

    private setQsReponseTaillePoids(qsForm: FormGroup, reponse: any) {
        qsForm.controls[`${reponse.numero}Weight`]?.setValue(reponse.poids);
        qsForm.controls[`${reponse.numero}Height`]?.setValue(
            reponse.tailleM + '' + reponse.tailleCm
        );
    }

    private setQsReponsesOuiNon(
        qsForm: FormGroup,
        reponse: any,
        questionChapeauComponents: QueryList<QuestionChapeauComponent>,
        questionMotifComponents: QueryList<QuestionMotifComponent>
    ) {
        qsForm.controls[reponse.numero].setValue(reponse.ouiNon === 'oui');
        if (reponse.ouiNon === 'oui') {
            this.setQsReponsesOui(
                qsForm,
                reponse,
                questionChapeauComponents,
                questionMotifComponents
            );
        }
    }

    private setQsReponsesOui(
        qsForm: FormGroup,
        reponse: any,
        questionChapeauComponents: QueryList<QuestionChapeauComponent>,
        questionMotifComponents: QueryList<QuestionMotifComponent>
    ) {
        let reponseComponent = null;
        let listSousQuestionComponent = null;
        if (reponse.id.includes('.')) {
            const idQuestionChapeau = reponse.id.substr(
                0,
                reponse.id.indexOf('.')
            );
            const questionChapeauComponent = questionChapeauComponents.filter(
                (element) =>
                    element.questionQuestionnaireSante.id === idQuestionChapeau
            )[0];
            listSousQuestionComponent =
                questionChapeauComponent.sousQuestionsMotifs;
        } else {
            listSousQuestionComponent = questionMotifComponents;
        }
        reponseComponent = listSousQuestionComponent.filter(
            (element) =>
                element.questionQuestionnaireSante.numero === reponse.numero
        )[0];
        if (reponseComponent) {
            reponseComponent.showExtraPanel();
        }
        if (reponse.listeReponsesSousQuestionSante) {
            this.setSousReponses(reponse, reponseComponent, qsForm);
        }
    }

    private setSousReponses(
        reponse: any,
        reponseComponent: any,
        qsForm: FormGroup
    ) {
        let i = 0;
        reponse.listeReponsesSousQuestionSante.forEach(
            (reponseSousQuestion) => {
                if (i !== 0 && reponseComponent) {
                    reponseComponent.addMotif();
                }
                reponseSousQuestion.listeElements.forEach((element) => {
                    const timeout = setInterval(
                        (controlId) => {
                            if (qsForm.controls[`${element.id}-${controlId}`]) {
                                clearInterval(timeout);
                                this.setQsInputValues(
                                    qsForm,
                                    element,
                                    controlId
                                );
                            }
                        },
                        100,
                        i
                    );
                });
                i++;
            }
        );
    }

    private setQsInputValues(
        qsForm: FormGroup,
        element: any,
        controlId: number
    ) {
        if (element.chaine) {
            qsForm.controls[`${element.id}-${controlId}`].setValue({
                id: controlId,
                numero: `${element.id}-${controlId}`,
                libelle: element.chaine,
            });
        } else if (element.entier) {
            qsForm.controls[`${element.id}-${controlId}`].setValue(
                element.entier
            );
        } else if (element.dateAnnee) {
            if (element.dateJour) {
                qsForm.controls[`${element.id}-${controlId}`].setValue(
                    moment(
                        element.dateJour +
                            '/' +
                            element.dateMois +
                            '/' +
                            element.dateAnnee,
                        'DD/MM/YYYY'
                    )
                );
            } else {
                qsForm.controls[`${element.id}-${controlId}`].setValue(
                    moment(
                        element.dateMois + '/' + element.dateAnnee,
                        'MM/YYYY'
                    )
                );
            }
        }
    }
}
